import { GlobalStyles, Grid2 as Grid } from '@mui/material';
import { READ_EMPLOYEE_DASHBOARD } from 'domain/shared/employee';
import { useAuthorization } from 'framework/authorization';
import { ShowSection } from 'framework/ui/layout';
import EmployeeTabsMenu from '../shared/EmployeeTabsMenu';
import { useDashboardCallbacks } from '../dashboard/hooks/useDashboardCallbacks';
import employeeDataGetters from '../dashboard/utils/employeeDataGetters';
import { EmployeeProfileInfo, EmployeeDashboardSection } from './components';
import { DashboardProvider } from 'framework/ui/dashboard';
import { DashboardFieldsProvider } from 'domain/shared/core/dashboard';

/**
 * EmployeeCard - A component that displays employee information in a ProfileCard layout
 * Shows employee photo, name, badges, position, status, country, and contact details
 */
const EmployeeCard = () => {
  const { isGranted } = useAuthorization();

  const canEditDashboard = isGranted(READ_EMPLOYEE_DASHBOARD);

  const dashboardCallbacks = useDashboardCallbacks();

  return (
    <DashboardProvider dataGetters={employeeDataGetters}>
      <GlobalStyles styles={{ body: { overflowY: 'scroll' } }} />
      <DashboardFieldsProvider {...dashboardCallbacks}>
        <ShowSection>
          <Grid
            container
            spacing={2}
            alignItems="flex-start"
            wrap="nowrap"
            justifyContent="space-between"
            sx={{
              flexDirection: {
                lg: 'row',
              },
            }}
          >
            <EmployeeProfileInfo canEditDashboard={canEditDashboard} />
            <EmployeeDashboardSection canEditDashboard={canEditDashboard} dashboardCallbacks={dashboardCallbacks} />
          </Grid>
          <Grid container sx={{ mt: 2 }}>
            <Grid size={{ xs: 12 }}>
              <EmployeeTabsMenu />
            </Grid>
          </Grid>
        </ShowSection>
      </DashboardFieldsProvider>
    </DashboardProvider>
  );
};

export default EmployeeCard;
